import { axiosInstance } from "../../../../utils/api";

const encodePathSegment = (value: string) => encodeURIComponent(value);

const unwrapA9 = async (request: Promise<any>) => {
  try {
    const response = await request;
    return response.data;
  } catch (error: any) {
    const statusCode = typeof error?.response?.status === "number" ? error.response.status : null;
    return {
      status: false,
      error: {
        code: error?.response?.data?.error?.code || null,
        message: error?.response?.data?.error?.message || error?.message || 'Request failed',
        details: error?.response?.data?.error?.details,
        statusCode,
      },
    };
  }
};

export const getEdmDatasetsRequest = async (params?: Record<string, unknown>) =>
  unwrapA9(axiosInstance.get('/admin/edm/datasets', { params }));

export const createEdmDatasetRequest = async (payload: Record<string, unknown>) =>
  unwrapA9(axiosInstance.post('/admin/edm/datasets', payload));

export const getEdmDatasetRequest = async (datasetKey: string) =>
  unwrapA9(axiosInstance.get(`/admin/edm/datasets/${encodePathSegment(datasetKey)}`));

export const updateEdmDatasetRequest = async (datasetKey: string, payload: Record<string, unknown>) =>
  unwrapA9(axiosInstance.patch(`/admin/edm/datasets/${encodePathSegment(datasetKey)}`, payload));

export const recomputeEdmDatasetRequest = async (datasetKey: string, payload?: Record<string, unknown>) =>
  unwrapA9(axiosInstance.post(`/admin/edm/datasets/${encodePathSegment(datasetKey)}/recompute`, payload || {}));

export const getEdmDatasetSummaryRequest = async (datasetKey: string, profileId?: string | null) =>
  unwrapA9(axiosInstance.get(`/admin/edm/datasets/${encodePathSegment(datasetKey)}/summary`, { params: profileId ? { profileId } : undefined }));

export const getEdmDatasetBlockedRequest = async (datasetKey: string, profileId?: string | null) =>
  unwrapA9(axiosInstance.get(`/admin/edm/datasets/${encodePathSegment(datasetKey)}/blocked`, { params: profileId ? { profileId } : undefined }));

export const validateEdmDatasetMediaRequest = async (datasetKey: string, payload?: Record<string, unknown>) =>
  unwrapA9(axiosInstance.post(`/admin/edm/datasets/${encodePathSegment(datasetKey)}/validate-media`, payload || {}));

export const getEdmDatasetHandoffPackageRequest = async (datasetKey: string, profileId?: string | null) =>
  unwrapA9(axiosInstance.get(`/admin/edm/datasets/${encodePathSegment(datasetKey)}/handoff-package`, { params: profileId ? { profileId } : undefined }));

export const getEdmPolicyRequest = async () =>
  unwrapA9(axiosInstance.get('/admin/edm/policy'));

export const deleteEdmDatasetRequest = async (datasetKey: string) =>
  unwrapA9(axiosInstance.delete(`/admin/edm/datasets/${encodePathSegment(datasetKey)}`));

export const getEdmArtworksRequest = async (params?: Record<string, unknown>) =>
  unwrapA9(axiosInstance.get('/admin/edm/artworks', { params }));

export const getEdmArtworkRequest = async (artworkId: string) =>
  unwrapA9(axiosInstance.get(`/admin/edm/artworks/${encodePathSegment(artworkId)}`));

export const updateEdmArtworkProfileRequest = async (artworkId: string, payload: Record<string, unknown>, profileId?: string | null) =>
  unwrapA9(axiosInstance.patch(`/admin/edm/artworks/${encodePathSegment(artworkId)}/profile`, payload, { params: profileId ? { profileId } : undefined }));

export const recomputeEdmArtworkRequest = async (artworkId: string, payload?: Record<string, unknown>) =>
  unwrapA9(axiosInstance.post(`/admin/edm/artworks/${encodePathSegment(artworkId)}/recompute`, payload || {}));

export const transitionEdmArtworkRequest = async (artworkId: string, payload: Record<string, unknown>) =>
  unwrapA9(axiosInstance.post(`/admin/edm/artworks/${encodePathSegment(artworkId)}/transition`, payload));

export const validateEdmArtworkMediaRequest = async (artworkId: string, payload?: Record<string, unknown>) =>
  unwrapA9(axiosInstance.post(`/admin/edm/artworks/${encodePathSegment(artworkId)}/validate-media`, payload || {}));
